import {Product, ProductFeature} from '../model';

export const useProductFeatures = () => {
  const hasProductFeatures = (product: Product): boolean => {
    return !!product.features;
  };

  const extractAccessNumbers = (product: Product): string[] => {
    if (!product.features) return [];

    return product.features.reduce<string[]>(
      (accessNumbers, {featureProperties}) =>
        featureProperties?.accessNumberId ? [...accessNumbers, featureProperties.accessNumberId] : accessNumbers,
      []
    );
  };

  const getFeature = (product: Product, id: string): ProductFeature | undefined => {
    return product.features?.find((feature) => feature.id === id);
  };

  return {
    hasProductFeatures,
    extractAccessNumbers,
    getFeature,
  };
};
